<template>
	<view class="box">
		<view class="head">
			<u-search
				placeholder="搜索会员昵称/手机号"
				:showAction="false"
				bgColor="#F8F9FB"
				placeholderColor="#999999"
				searchIconSize="28"
				height="36"
				v-model="keyword" />
			<view class="head-cate">
				<view class="head-cate-item">
					<text class="num">5,323</text>
					<text class="title">会员总数</text>
				</view>
				<view class="head-cate-item">
					<text class="num">3,289</text>
					<text class="title">订单总数</text>
				</view>
				<view class="head-cate-item">
					<view class="price">
						<text>5,323</text>
						<text>.00</text>
					</view>
					<text class="title">订单金额</text>
				</view>
			</view>
		</view>
		<view class="list">
			<view class="list-item">
				<view class="tx">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
				<view class="info">
					<view class="info-a">
						<text>李婷平</text>
						<text>1815****5556</text>
					</view>
					<view class="info-date">关联时间：2024-04-18 19:29:01</view>
					<view class="info-num">
						<text>订单量：3</text>
						<text>订单金额：¥3678.00</text>
					</view>
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.head {
			width: 100%;
			height: 242rpx;
			padding: 20rpx 30rpx 0 30rpx;
			box-sizing: border-box;
			background: #FFFFFF;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 99;
			.head-cate {
				width: 100%;
				height: 150rpx;
				
				display: flex;
				align-items: center;
				.head-cate-item {
					flex: 1;
					height: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					.price {
						display: flex;
						align-items: baseline;
						text {
							&:nth-child(1) {
								font-weight: 600;
								font-size: 32rpx;
								color: #E4001D;
								&::before {
									content: '￥';
									font-weight: 600;
									font-size: 24rpx;
									color: #E4001D;
								}
							}
							&:nth-child(2) {
								font-weight: 600;
								font-size: 24rpx;
								color: #E4001D;
							}
						}
					}
					.num {
						font-weight: 600;
						font-size: 32rpx;
						color: #222222;
					}
					.title {
						font-weight: 400;
						font-size: 26rpx;
						color: #555555;
						margin-top: 10rpx;
					}
				}
			}
		}
		.list {
			width: 100%;
			margin-top: 20rpx;
			background-color: #ffffff;
			padding: 0 30rpx;
			box-sizing: border-box;
			.list-item {
				width: 100%;
				padding: 30rpx 0;
				box-sizing: border-box;
				border-bottom: 1rpx solid #E5E5E5;
				display: flex;
				align-items: flex-start;
				.tx {
					width: 80rpx;
					height: 80rpx;
					flex-shrink: 0;
					border-radius: 50%;
					overflow: hidden;
					margin-right: 20rpx;
					image {
						width: 100%;
					}
				}
				.info {
					flex: 1;
					display: flex;
					flex-direction: column;
					.info-a {
						width: 100%;
						display: flex;
						align-items: center;
						text {
							&:nth-child(1) {
								font-weight: 400;
								font-size: 30rpx;
								color: #222222;
								margin-right: 20rpx;
							}
							&:nth-child(2) {
								font-weight: 400;
								font-size: 24rpx;
								color: #999999;
							}
						}
					}
					.info-date {
						font-weight: 400;
						font-size: 24rpx;
						color: #999999;
						margin-top: 10rpx;
					}
					.info-num {
						width: 80%;
						display: flex;
						align-items: center;
						justify-content: space-between;
						margin-top: 20rpx;
						text {
							font-weight: 400;
							font-size: 26rpx;
							color: #333333;
						}
					}
				}
			}
		}
	}
</style>